import { PitchingProgressState } from 'enums/PitchingProgressState';
import { action, makeObservable, observable } from 'mobx';

export const MAX_CALIBRATION_COUNT_NUMBER = 20;
export const MAX_HOME_PLATE_COUNT_NUMBER = 10;

export class FieldCalibrationStore {
  // TODO: Landing area
  @observable bounceWithin5FeetFromHPCount: number;

  // TODO: Homeplate
  @observable hitHPCount: number;

  @observable totalCount: number;

  @observable isFieldCalibration: boolean;

  @observable pitchingProgressState?: PitchingProgressState;

  @observable abortModalVisible: boolean = false;

  @observable calibrationConfirmModalVisible = false;

  @observable hitHP: boolean = false;

  @observable bounceWithin5FeetFromHP: boolean = false;

  @observable breaksTracked: boolean = false;

  constructor() {
    this.bounceWithin5FeetFromHPCount = 0;
    this.hitHPCount = 0;
    this.totalCount = 0;
    this.isFieldCalibration = false;
    this.pitchingProgressState = PitchingProgressState.StartPitching;
    makeObservable(this);
  }

  @action setBreaksTracked = (value: boolean) => {
    this.breaksTracked = value;
  };

  @action incrementValidCount = (): void => {
    this.bounceWithin5FeetFromHPCount++;
    this.pitchingProgressState = PitchingProgressState.PitchRegistered;
    this.bounceWithin5FeetFromHP = true;
    this.hitHP = false;
  };

  @action incrementInvalidCount = (): void => {
    this.hitHPCount++;
    this.pitchingProgressState = PitchingProgressState.TryAgain;
    this.hitHP = true;
    this.bounceWithin5FeetFromHP = false;
  };

  @action incrementTotalCount = (): void => {
    this.totalCount++;
  };

  @action setIsFieldCalibration(isFieldCalibration: boolean): void {
    this.isFieldCalibration = isFieldCalibration;
  }

  @action setPitchingProgressState(isCalibrationStarted: PitchingProgressState): void {
    this.pitchingProgressState = isCalibrationStarted;
  }

  @action reset = (): void => {
    this.bounceWithin5FeetFromHPCount = 0;
    this.hitHPCount = 0;
    this.totalCount = 0;
    this.pitchingProgressState = PitchingProgressState.StartPitching;
    this.setAbortModalVisible(false);
    this.setIsFieldCalibration(false);
  };

  @action setAbortModalVisible = (value: boolean) => {
    this.abortModalVisible = value;
  };

  @action setCalibrationConfirmModalVisible = (value: boolean) => {
    this.calibrationConfirmModalVisible = value;
  };
}
